export default __webpack_public_path__ + "static/redesign-51469663f80131bdf812bcd8110c9e3a.png";